import AlertModal from "library/Molecules/Modal/AlertModal";
import { useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toggleIncompletePaymentWarning } from "store/features/contact.store";
import { setOrderFilters } from "store/features/order.store";
import { FAILED_PAYMENT_STATUS } from "../../constants";

const IncompletePaymentsModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onToggleWarning = useCallback((flag) => dispatch(toggleIncompletePaymentWarning({ value: flag })), [dispatch]);

  const onConfirm = useCallback(() => {
    onToggleWarning(null);
    dispatch(setOrderFilters({ paymentStatus: FAILED_PAYMENT_STATUS }));
    navigate("/");
  }, [dispatch, navigate, onToggleWarning]);
  const onClose = useCallback(() => onToggleWarning(false), [onToggleWarning]);

  return (
    <AlertModal
      id="incomplete-payments-modal"
      title={t("features.incompletePaymentsModal.title")}
      description={<Trans i18nKey="features.incompletePaymentsModal.description" />}
      closeBtnText={t("features.incompletePaymentsModal.checkOrdersBtn")}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};

export default IncompletePaymentsModal;
